import type { Node } from '@tiptap/pm/model';
import type { EditorState, Transaction } from '@tiptap/pm/state';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { canJoin } from '@tiptap/pm/transform';

import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';

export const createMergingSiblingListNodesTransactionPlugin = () => {
  return new Plugin({
    key: new PluginKey('merge-sibling-list-nodes'),
    appendTransaction: (_, _oldState: EditorState, newState: EditorState) => {
      if (newState.doc === _oldState.doc) {
        return;
      }
      let tr = newState.tr;

      // first merges all outermost list nodes that are siblings in the document and have the same offset
      tr = mergeListNodes(tr);

      // then merges list nodes that are siblings and have the same offset
      tr.doc.descendants((node: Node, pos: number) => {
        if (node.type.name !== Node_Type.LIST_ITEM || node.childCount < 2) {
          return;
        }
        mergeListNodes(tr, node, pos + 1);
      });

      return tr;
    },
  });
};

const mergeListNodes = (tr: Transaction, node = tr.doc, pos = 0) => {
  const validNodeTypes = [Node_Type.BULLETED_LIST, Node_Type.ORDERED_LIST];
  let prevOffset: number | null = null;

  let joinedCount = 0;
  node.forEach((childNode: Node, childPos: number) => {
    if (!validNodeTypes.includes(childNode.type.name as Node_Type)) {
      prevOffset = null;
      return;
    }

    const shouldBeMerged = prevOffset === childNode.attrs.offset;
    prevOffset = childNode.attrs.offset;

    const newPos = childPos + pos - joinedCount * 2;

    if (shouldBeMerged && canJoin(tr.doc, newPos)) {
      tr.join(newPos);
      joinedCount++;
    }
  });
  return tr;
};
